import { install, uninstall } from "@github/hotkey";

// Install declarative hotkeys (data-hotkey) on each page render, and tear them
// down before Turbo caches the page so the registry doesn't keep stale or
// double-registered elements across navigations.
document.addEventListener("turbo:load", function () {
  for (const el of document.querySelectorAll("[data-hotkey]")) {
    install(el);
  }
});

document.addEventListener("turbo:before-cache", function () {
  for (const el of document.querySelectorAll("[data-hotkey]")) {
    uninstall(el);
  }
});
